(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-bond-flow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const container = document.getElementById('custom-bond-flow');
  const backdrop = document.getElementById('flow-backdrop');

  if(container) {
    container.style.display = 'flex';
    backdrop.style.display = 'block';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('bond-flow-active');
  }

  const basePrice = parseFloat(container.dataset.basePrice) || 0;
  
  const state = {
    mainVariantId: null,
    colorName: '',
    packaging: { name: '', price: 0, variantId: null, isVirtual: false, netPrice: 0 },
    addons: [] 
  };

  const currencyFormatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0
  });

  function updateTotalDisplay() {
    let addonsTotal = 0;
    document.querySelectorAll('.addon-check:checked').forEach(chk => {
      const price = parseFloat(chk.dataset.price) || 0;
      addonsTotal += price;
    });

    // Si el empaque elegido es "Virtual", el total se calcula sobre el valor neto real
    // del Bono Virtual (state.packaging.netPrice) en vez de sumar deltas sobre el precio base.
    let rawTotal;
    if (state.packaging.isVirtual) {
      rawTotal = state.packaging.netPrice + addonsTotal;
    } else {
      rawTotal = basePrice + state.packaging.price + addonsTotal;
    }
    const finalTotal = rawTotal / 100; 

    const formatted = currencyFormatter.format(finalTotal);
    document.querySelectorAll('.current-total-amount').forEach(el => {
      el.textContent = formatted;
    });
  }

  function goToStep(stepId) {
    document.querySelectorAll('.flow-step').forEach(el => {
      el.classList.remove('active');
      el.classList.add('hidden');
    });
    const target = document.getElementById(stepId);
    if(target) {
      target.classList.remove('hidden');
      target.classList.add('active');
    }
  }

  function updatePackImages() {
    const selectedColor = state.colorName ? state.colorName.toLowerCase().trim() : '';
    document.querySelectorAll('.pack-option').forEach(opt => {
      const imgMapString = opt.dataset.images;
      if (imgMapString) {
        const imgMap = JSON.parse(imgMapString); 
        const imgElement = opt.querySelector('.dynamic-pack-img');
        let matchedImg = null;
        for (const [variantName, imgUrl] of Object.entries(imgMap)) {
          if (variantName.includes(selectedColor) || selectedColor.includes(variantName)) {
            matchedImg = imgUrl; break;
          }
        }
        if (matchedImg && imgElement) imgElement.src = matchedImg;
      }
    });
  }

  document.querySelectorAll('.btn-next, .btn-prev, .btn-skip').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      let target = btn.dataset.target;
      const currentStep = btn.closest('.flow-step');
      const currentStepId = currentStep ? currentStep.id : null;

      if(target === 'step-2') {
        if(!state.mainVariantId) return alert("Selecciona un color.");
        updatePackImages();
      }

      // Al avanzar desde el paso 2 (empaque) es obligatorio haber elegido un tipo de empaque.
      if(currentStepId === 'step-2' && target !== 'step-1') {
        if(!state.packaging.name) return alert("Selecciona un tipo de empaque.");
        // Bono Virtual: se salta el paso de Acompañantes y va directo a Datos Bono.
        if(state.packaging.isVirtual) target = 'step-4';
      }

      // Al retroceder desde el paso 4, si es Bono Virtual, se vuelve directo al paso 2 (se saltó Acompañantes).
      if(currentStepId === 'step-4' && target === 'step-3' && state.packaging.isVirtual) {
        target = 'step-2';
      }

      goToStep(target);
    });
  });
  const colorBtns = document.querySelectorAll('.color-btn');
  colorBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      colorBtns.forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
      state.mainVariantId = this.dataset.variantId;
      state.colorName = this.dataset.color;
      if(this.dataset.img) document.getElementById('main-bond-image').src = this.dataset.img;
    });
  });
  const btnArma = document.getElementById('btn-arma-tu-bono');
  if(btnArma) btnArma.addEventListener('click', () => {
      if(!state.mainVariantId) return alert("Selecciona un color");
      updatePackImages();
      goToStep('step-2');
  });
  const btnCombos = document.getElementById('btn-ver-combos');
  if(btnCombos) btnCombos.addEventListener('click', function() {
      //if(!state.mainVariantId) return alert("Selecciona un color primero.");
      const baseUrl = this.dataset.url;
      window.location.href = `${baseUrl}`;
  });
  const packOptions = document.querySelectorAll('.pack-option');
  function selectPack(element) {
    packOptions.forEach(p => p.classList.remove('selected'));
    element.classList.add('selected');
    // LOGICA SINCRONIZACIÓN COLOR
    const idMapString = element.dataset.variantIds; 
    const defaultId = element.dataset.defaultVariantId;
    let selectedId = defaultId;
    if(idMapString) {
      const idMap = JSON.parse(idMapString);
      const chosenColor = state.colorName.toLowerCase();
      for (const [vName, vId] of Object.entries(idMap)) {
        if (vName.includes(chosenColor) || chosenColor.includes(vName)) {
          selectedId = vId;
          break;
        }
      }
    }

    const price = parseFloat(element.dataset.price) || 0;
    const isVirtual = element.dataset.isVirtual === 'true';
    const netPrice = parseFloat(element.dataset.netPrice) || 0;
    state.packaging = { name: element.dataset.packName, price: price, variantId: selectedId, isVirtual: isVirtual, netPrice: netPrice };
    updateTotalDisplay();
    if(typeof updateVirtualFormMode === 'function') updateVirtualFormMode(isVirtual);

    // Mostrar la nota del Bono Virtual solo si el empaque seleccionado es Virtual
    const virtualNote = document.getElementById('virtual-pack-note');
    if(virtualNote) virtualNote.classList.toggle('hidden-field', !isVirtual);
  }
  // No se preselecciona ningún empaque: el usuario debe elegir uno explícitamente.
  packOptions.forEach(opt => opt.addEventListener('click', function(){ selectPack(this) }));

  document.addEventListener('change', function(e) {
    if(e.target.classList.contains('addon-check')) updateTotalDisplay();
  });

  // === LIGHTBOX DE IMÁGENES EN ACOMPAÑANTES ===
  const lightboxOverlay = document.getElementById('addon-lightbox-overlay');
  const lightboxImg = document.getElementById('addon-lightbox-img');
  const lightboxClose = document.getElementById('addon-lightbox-close');

  function openAddonLightbox(src, alt) {
    if(!lightboxOverlay || !lightboxImg || !src) return;
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightboxOverlay.classList.add('active');
  }
  function closeAddonLightbox() {
    if(!lightboxOverlay) return;
    lightboxOverlay.classList.remove('active');
    lightboxImg.src = '';
  }
  // Delegación: funciona con cualquier imagen dentro de .addon-item (usa data-zoom-src si existe, o el src actual)
  document.addEventListener('click', function(e) {
    const addonImg = e.target.closest('.addon-item img');
    if(addonImg) {
      const fullSrc = addonImg.getAttribute('data-zoom-src') || addonImg.currentSrc || addonImg.src;
      openAddonLightbox(fullSrc, addonImg.alt);
    }
  });
  if(lightboxClose) lightboxClose.addEventListener('click', closeAddonLightbox);
  if(lightboxOverlay) lightboxOverlay.addEventListener('click', function(e) {
    if(e.target === lightboxOverlay) closeAddonLightbox();
  });
  document.addEventListener('keydown', function(e) {
    if(e.key === 'Escape') closeAddonLightbox();
  });

  const tabBtns = document.querySelectorAll('.tab-btn');
  const colGroups = document.querySelectorAll('.collection-group');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      tabBtns.forEach(t => t.classList.remove('active'));
      btn.classList.add('active');
      const targetCol = btn.dataset.targetCollection; 
      colGroups.forEach(group => { group.classList.remove('visible'); group.classList.add('hidden-group'); });
      const activeGroup = document.getElementById('col-' + targetCol);
      if(activeGroup) { activeGroup.classList.remove('hidden-group'); activeGroup.classList.add('visible'); }
    });
  });
  //LÓGICA DE CONTADOR DE CARACTERES (los espacios NO cuentan como carácter)
  const textarea = document.getElementById('card_message');
  const counter = document.getElementById('chars_left');
  const maxLength = parseInt(textarea.dataset.maxChars, 10) || 170;
  counter.textContent = maxLength;

  function countNonSpaceChars(str) {
    return str.replace(/\s/g, '').length;
  }

  textarea.addEventListener('input', function() {
    let value = textarea.value;
    let nonSpaceCount = countNonSpaceChars(value);

    // Si se supera el límite de caracteres (sin contar espacios), se recorta el exceso
    if (nonSpaceCount > maxLength) {
      let result = '';
      let count = 0;
      for (const ch of value) {
        if (/\s/.test(ch)) {
          result += ch;
        } else if (count < maxLength) {
          result += ch;
          count++;
        }
      }
      value = result;
      textarea.value = value;
      nonSpaceCount = maxLength;
    }

    const remaining = maxLength - nonSpaceCount;
    counter.textContent = remaining;

    // Opcional: Cambiar el color si quedan pocos caracteres
    if (remaining <= 10) {
      counter.style.color = 'red';
    } else {
      counter.style.color = 'inherit';
    }
  });

  // === MENSAJE ADICIONAL OPCIONAL ===
  // 1) El campo de mensaje empieza oculto.
  // 2) Cuando el remitente termina de escribir su nombre, aparece la casilla de "quiero mensaje adicional".
  // 3) Solo si la marcan, se muestra de nuevo el campo de mensaje.
  const senderNameInput = document.getElementById('sender_name');
  const additionalMsgToggleWrap = document.getElementById('additional_message_toggle_wrap');
  const wantAdditionalMsgCheckbox = document.getElementById('want_additional_message');
  const cardMessageGroup = document.getElementById('card_message_group');

  function refreshAdditionalMessageUI() {
    const senderFilled = senderNameInput && senderNameInput.value.trim().length > 0;
    if (additionalMsgToggleWrap) {
      additionalMsgToggleWrap.classList.toggle('hidden-field', !senderFilled);
    }
    if (!senderFilled && wantAdditionalMsgCheckbox) {
      wantAdditionalMsgCheckbox.checked = false;
    }
    const showMessageField = senderFilled && wantAdditionalMsgCheckbox && wantAdditionalMsgCheckbox.checked;
    if (cardMessageGroup) {
      cardMessageGroup.classList.toggle('hidden-field', !showMessageField);
    }
  }

  if (senderNameInput) senderNameInput.addEventListener('input', refreshAdditionalMessageUI);
  if (wantAdditionalMsgCheckbox) wantAdditionalMsgCheckbox.addEventListener('change', refreshAdditionalMessageUI);
  refreshAdditionalMessageUI();

  // === MODO BONO VIRTUAL EN PASO 4 ===
  // Alterna entre el bloque de envío físico y el bloque de envío virtual,
  // y ajusta qué campos son obligatorios.
  function updateVirtualFormMode(isVirtual) {
    const physicalBlock = document.getElementById('shipping-physical-block');
    const virtualBlock = document.getElementById('shipping-virtual-block');
    if (physicalBlock) physicalBlock.classList.toggle('hidden-field', !!isVirtual);
    if (virtualBlock) virtualBlock.classList.toggle('hidden-field', !isVirtual);
  }
  // === VALIDACIÓN PASO 4 Y AVANCE A PASO 5 (CONFIRMACIÓN) ===
  function validateStep4Fields() {
    const isVirtual = !!state.packaging.isVirtual;
    const recipient = document.getElementById('recipient_name').value.trim();
    const sender = document.getElementById('sender_name').value.trim();
    const habeasChecked = document.getElementById('habeas_data_consent') ? document.getElementById('habeas_data_consent').checked : false;

    if(!recipient || !sender) { alert("Completa los campos obligatorios (*)"); return false; }

    if(isVirtual) {
      const senderPhone = document.getElementById('sender_phone') ? document.getElementById('sender_phone').value.trim() : '';
      const senderEmail = document.getElementById('sender_email') ? document.getElementById('sender_email').value.trim() : '';
      if(!senderPhone || !senderEmail) { alert("Completa los campos obligatorios (*)"); return false; }
    } else {
      const address = document.getElementById('delivery_address').value.trim();
      const recipientPhone = document.getElementById('recipient_phone').value.trim();
      const additionalNotes = document.getElementById('additional_notes').value.trim();
      if(!address || !recipientPhone || !additionalNotes) { alert("Completa los campos obligatorios (*)"); return false; }
    }

    if(!habeasChecked) { alert("Debes aceptar la autorización de tratamiento de datos personales (Habeas Data) para continuar."); return false; }

    return true;
  }

  const btnGoToConfirm = document.getElementById('btn-go-to-confirm');
  if(btnGoToConfirm) {
    btnGoToConfirm.addEventListener('click', function() {
      if(!validateStep4Fields()) return;
      goToStep('step-5');
    });
  }

  // LOGICA FINAL DE CARRITO
  const btnFinal = document.getElementById('btn-final-add-to-cart');
  if(btnFinal) {
    btnFinal.addEventListener('click', function() {
      const isVirtual = !!state.packaging.isVirtual;

      const recipient = document.getElementById('recipient_name').value.trim();
      const sender = document.getElementById('sender_name').value.trim();
      const habeasChecked = document.getElementById('habeas_data_consent') ? document.getElementById('habeas_data_consent').checked : false;

      // Campos obligatorios comunes
      if(!recipient || !sender) return alert("Completa los campos obligatorios (*)");

      let address = '', recipientPhone = '', additionalNotes = '', senderPhone = '', senderEmail = '';

      if(isVirtual) {
        // Bono Virtual: solo se exigen nombre, teléfono y correo del remitente
        senderPhone = document.getElementById('sender_phone') ? document.getElementById('sender_phone').value.trim() : '';
        senderEmail = document.getElementById('sender_email') ? document.getElementById('sender_email').value.trim() : '';
        if(!senderPhone || !senderEmail) return alert("Completa los campos obligatorios (*)");
      } else {
        // Bono físico: dirección, teléfono de quien recibe y notas adicionales
        address = document.getElementById('delivery_address').value.trim();
        recipientPhone = document.getElementById('recipient_phone').value.trim();
        additionalNotes = document.getElementById('additional_notes').value.trim();
        if(!address || !recipientPhone || !additionalNotes) return alert("Completa los campos obligatorios (*)");
      }

      if(!habeasChecked) return alert("Debes aceptar la autorización de tratamiento de datos personales (Habeas Data) para continuar.");

      let mainId = parseInt(state.mainVariantId);
      if(!mainId) return alert("Error: No se seleccionó el bono.");

      // --- MAGIA VIRTUAL ---
      if (state.packaging.name && state.packaging.name.toLowerCase().includes('virtual')) {
        const mapScript = document.getElementById('virtual-variant-map');
        if (mapScript) {
          try {
            const virtualMap = JSON.parse(mapScript.textContent);
            if (virtualMap[state.mainVariantId]) {
              mainId = parseInt(virtualMap[state.mainVariantId]);
              state.packaging.variantId = null; 
            }
          } catch (e) { console.error(e); }
        }
      }

      // CAPTURAR ETIQUETA OCASIÓN
      const occasionTagInput = document.getElementById('occasion_tag');
      const occasionTag = occasionTagInput ? occasionTagInput.value : '';

      const cardMessageValue = document.getElementById('card_message') ? document.getElementById('card_message').value : '';

      const properties = {
        'Color': state.colorName,
        'Tipo de Empaque': state.packaging.name,
        'Etiqueta Ocasión': occasionTag, 
        'Para': recipient,
        'De': sender,
        'Mensaje': cardMessageValue,
        'Fallecido': document.getElementById('deceased_name') ? document.getElementById('deceased_name').value : ''
      };

      if(isVirtual) {
        properties['Teléfono del remitente'] = senderPhone;
        properties['Correo del remitente'] = senderEmail;
      } else {
        properties['Dirección de Entrega'] = address;
        properties['Teléfono de quien recibe'] = recipientPhone;
        properties['Notas'] = additionalNotes;
      }

      const items = [];
      items.push({
        id: mainId,
        quantity: 1,
        properties: properties
      });
      // AQUI EL CAMBIO: Solo agregar empaque si tiene costo (> 0)
      if(state.packaging.variantId && state.packaging.price > 0) {
        const packId = parseInt(state.packaging.variantId);
        if(!isNaN(packId)) items.push({ id: packId, quantity: 1 });
      }

      document.querySelectorAll('.addon-check:checked').forEach(chk => {
        const addonId = parseInt(chk.value);
        if(!isNaN(addonId)) items.push({ id: addonId, quantity: 1 });
      });
      btnFinal.innerHTML = "Procesando...";
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ items: items })
      })
      .then(res => { 
        if(res.ok) window.location.href = '/checkout'; 
        else {
          console.error(res);
          throw new Error('Error agregando al carrito');
        }
      })
      .catch(err => { 
        console.error(err); 
        btnFinal.innerHTML = "Error. Reintentar."; 
        alert("Hubo un problema. Es posible que alguno de los productos seleccionados esté agotado."); 
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();
})();
